import React, { useState } from "react";
import axios from "axios";
import "./ContactPage.css";

function ContactPage() {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    date: "",
    gender: "",
    place: "",
    comment: ""
  });
  const [toast, setToast] = useState({ visible: false, type: "", message: "" });

  // Always use .env variable for API base URL
  const API_URL = `${process.env.REACT_APP_API_URL}/contact`;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // ✅ API call to save data in ContactTable
      await axios.post(API_URL, formData);
      setToast({ visible: true, type: "success", message: "Form submitted successfully!" });
      setFormData({
        name: "",
        email: "",
        date: "",
        gender: "",
        place: "",
        comment: ""
      });
    } catch (error) {
      setToast({ visible: true, type: "error", message: "Error submitting form" });
    }

    window.setTimeout(() => {
      setToast((prev) => ({ ...prev, visible: false }));
    }, 2800);
  };

  return (
    <>
      {toast.visible && (
        <div className={`contact-side-toast ${toast.type}`}>
          {toast.message}
        </div>
      )}
      <div className="contact-container">
      <h2>Contact Form</h2>
      <form onSubmit={handleSubmit} className="contact-form">
        <label>Name</label>
        <input type="text" name="name" value={formData.name} onChange={handleChange} required />

        <label>Email</label>
        <input type="email" name="email" value={formData.email} onChange={handleChange} required />

        <label>Date</label>
        <input type="date" name="date" value={formData.date} onChange={handleChange} required />

        <label>Gender</label>
        <select name="gender" value={formData.gender} onChange={handleChange} required>
          <option value="">Select</option>
          <option value="male">Male</option>
          <option value="female">Female</option>
          <option value="other">Other</option>
        </select>

        <label>Place</label>
        <input type="text" name="place" value={formData.place} onChange={handleChange} required />

        <label>Comment</label>
        <textarea name="comment" value={formData.comment} onChange={handleChange}></textarea>

        <button type="submit">Submit</button>
      </form>
      </div>
    </>
  );
}

export default ContactPage;
